import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";
import { useLocation, useParams } from "react-router-dom";
import { Paginator } from "primereact/paginator";

function withParams() {
    return (props) => <Store {...props} params={useParams()} location={useLocation()} />;
}

class Store extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            first: 0,
            rows: 20,
            totalRecords: 0,
            fileServer: getFileServer(),
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            const query = new URLSearchParams(this.props.location.search);

            const response = await productService.getByStatusAndTypeAndLikeName(
                "ACTIVE",
                "VIRTUAL",
                query.get("query"),
                query.get("supplier")
            );

            if (response.status === 200) {
                this.setState({ products: response.data.filter((p) => !p.child) });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    banners = [
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
    ];

    listPrices(product) {
        if (product.childProducts !== undefined) {
            var prices = "";
            product.childProducts.forEach((p) => (prices += "R$ " + p.amount + " | "));

            prices = prices.substring(0, prices.length - 3);
            return prices;
        } else {
            return "R$ " + product.amount;
        }
    }

    onPageChange = async (event) => {
        await showProcess();
        await this.setState({ first: 0, rows: 0 });
        await this.setState({ first: event.first, rows: event.rows });
        hideProcess();
    };

    render() {
        return (
            <>
                
                <section
                    class="app-cards-container"
                    style={{
                        marginTop: "25px",
                        padding: "10px",
                        width: "100%",
                        boxSizing: "border-box",
                        backgroundColor: "#F3F3F3"
                    }}
                >
                    <div style={{textAlign: "left", padding: "40px 40px 0px 40px"}}>
                        <label style={{fontSize: "27px", color: "var(--unnamed-color-411172)", fontWeight: "600"}}>Todos Cartões-Presente</label>
                    </div>                    
                    <div
                        class="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: "20px",
                            width: "100%",
                            
                        }}
                    >
                        {this.state.products
                            .filter((p) =>
                                p.displayName
                                    .toUpperCase()
                                    .includes(this.props.search.toUpperCase())
                            )
                            .splice(this.state.first, this.state.rows)
                            .map((p) => (
                                <div
                                    className="app-card-product"
                                    onClick={() => (window.location.href = "/product/" + p.id)}
                                    style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #ddd",
                                        borderRadius: "10px",
                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        padding: "35px 0px 50px",
                                        width: window.innerWidth < 768 ? "90%" : "387px", // ← aqui o ajuste
                                        minWidth: "150px",
                                        textAlign: "center",
                                        transition: "transform 0.2s ease-in-out",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "auto",
                                        margin: window.innerWidth < 768 ? "10px auto" : "0", // centraliza no mobile
                                    }}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.style.transform = "scale(1.05)")
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.style.transform = "scale(1)")
                                    }
                                >
                                    <img
                                        src={`${this.state.fileServer}/cards/${p.id}.png`}
                                        alt={p.displayName}
                                        style={{
                                            width: "100%",
                                            height: "227px",
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                    <span
                                        className="app-card-product-name"
                                        style={{
                                            display: "block",
                                            fontSize: "32px",
                                            fontWeight: "500",
                                            color: "#000141",
                                            minHeight: "40px",
                                            lineHeight: "1.2em",
                                            marginBottom: "5px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {p.displayName}
                                    </span>
                                    <p
                                        className="app-card-product-price"
                                        style={{
                                            color: "#707070",
                                            fontSize: "20px",
                                            margin: "10px 0",
                                            flexGrow: 0,
                                        }}
                                    >
                                        {this.listPrices(p)}
                                    </p>
                                    
                                    <div style={{width:"100%", textAlign: "center"}}>
                                        <button
                                            style={{
                                                backgroundColor: "#411172",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "50px",
                                                padding: "20px 40px",
                                                fontSize: "18px",
                                                cursor: "pointer",
                                                width: "fit-content",
                                                fontWeight: "400",
                                                marginTop: "auto",
                                            }}
                                        >
                                            Comprar
                                        </button>
                                    </div>
                                    
                                </div>
                            ))}
                        <br />
                        {this.state.products.length > 20 && (
                            <Paginator
                                first={this.state.first}
                                rows={this.state.rows}
                                totalRecords={this.state.products.length}
                                rowsPerPageOptions={[10, 20, 30]}
                                onPageChange={this.onPageChange}
                            />
                        )}
                    </div>
                </section>
            </>
        );
    }
}

export default withParams();
